import { useCompanyQuery } from '../../../../features/company/useCompanyQuery';
import { useIsWithinLinkedin } from '../../../../hooks/useIsWithinLinkedin';
import { useIsWithinTools } from '../../../../hooks/useIsWithinTools';
import { translate } from '../../../../services/i18n';
import { useDispatchTrackEventWithLocation } from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { SectionHeader } from '../../SectionHeader/SectionHeader';

export const TechnologiesHeader = () => {
  const { data } = useCompanyQuery();
  const companyDomain = data?.domain;

  const isWithinLinkedin = useIsWithinLinkedin();
  const { isWithinCalendar } = useIsWithinTools();
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const handleTrackSeeMoreTechnologies = () =>
    dispatchTrackEventWithLocation('company data', 'open tech in platform', `see all tech/${companyDomain || ''}`);

  return (
    <SectionHeader
      title={translate('company.technologies.title')}
      subtitle={translate(
        isWithinLinkedin || isWithinCalendar
          ? 'company.technologies.subtitle.linkedin'
          : 'company.technologies.subtitle'
      )}
      titleLink={
        companyDomain
          ? `https://pro.similarweb.com/#/sales/account-review/technologies/${companyDomain}?category=All`
          : undefined
      }
      onTitleLinkClick={handleTrackSeeMoreTechnologies}
      titleLinkTooltip={translate('company.technologies.link.tooltip')}
    />
  );
};
